import { translateKey } from '@frontend/translate';
import type { ICustomControlData } from './TcohV2DiagnosticReportAddEditCustomControlFields';
import { FormGroupRead } from '../../utils/v1/FormGroupRead';

export function TcohV2DiagnosticReportReadCustomControlFields(props: {
    customControlData: ICustomControlData;
    isSupervising?: boolean;
    txcsProcesId: string | null;
}) {
    return (
        <>
            <FormGroupRead
                label={translateKey('diagnosticReport.relationEcgAndComplaints')}
                value={props.customControlData.relatieEcgEnKlachten}
            />

            <FormGroupRead
                label={translateKey('diagnosticReport.additionalRemarks')}
                value={props.customControlData.overigeOpmerkingen}
            />
        </>
    );
}
